export namespace CssPropertiesValues {
  export const hidden = 'hidden';
  export const auto = 'auto';
  export const absolute = 'absolute';
}
